import { SET_SIGN_IN } from "../../constants/onlineShopper";

export interface SetSignIn {
    data: {
        routeSignIn: boolean;
    };
    type: SET_SIGN_IN;
}

export function setSignIn(data: { routeSignIn: boolean }): SetSignIn {
    return {
        data,
        type: SET_SIGN_IN,
    };
}
